import { Link } from "react-router-dom";

const highlights = [
  {
    icon: "ri-newspaper-line",
    title: "权威资讯",
    desc: "持续跟进活动报道、采访专访与作品发布，第一时间掌握她的最新动态。",
  },
  {
    icon: "ri-film-line",
    title: "作品全集",
    desc: "按类型、年份与角色类型筛选，系统查阅她参与的全部影视作品。",
  },
  {
    icon: "ri-user-star-line",
    title: "个人资料",
    desc: "从出道经历到代表作品，完整了解白石茉莉奈的成长轨迹与艺术成就。",
  },
];

export default function SiteIntro() {
  return (
    <section className="bg-background-100 rounded-lg border border-background-200 p-6 md:p-10">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
        <div className="lg:col-span-1">
          <span className="text-xs font-body tracking-[0.3em] text-accent-600">
            ABOUT THE PLATFORM
          </span>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mt-2 tracking-wide">
            明星动态平台
          </h2>
          <p className="text-sm text-foreground-500 leading-relaxed mt-4 font-body">
            本站以「白石茉莉奈」为品牌名称，专注呈现她的最新动态、影视作品与个人资料，
            以权威、丰富、结构清晰的方式，服务每一位关注她的粉丝与影视娱乐爱好者。
          </p>
          <Link
            to="/profile"
            className="inline-flex items-center gap-1.5 mt-6 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-body hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            查看完整个人资料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {highlights.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-lg border border-background-200 p-5"
            >
              <div className="w-11 h-11 rounded-md bg-secondary-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-secondary-600`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mt-2 font-body">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}